// extracted by mini-css-extract-plugin
export default {"table":"DocumentsTable-module__table__pWKm7","link":"DocumentsTable-module__link__8iNWw"};